/**
 * PreviewTile — 🆕 2026-08 · Kontroll-Kachel (Anker-Raster / Pass-Pfeil).
 * Lazy geladenes Mini-Standbild; Klick öffnet eine Lightbox in voller
 * Größe. Rendert nichts, wenn das Bild nicht ladbar ist (ehrlich leer).
 */
import React, { useState } from "react";

export function PreviewTile({ src, alt, caption, testId, tileClass = "h-14 w-auto" }) {
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <>
      <img
        data-testid={testId}
        src={src}
        alt={alt}
        loading="lazy"
        draggable={false}
        onError={() => setFailed(true)}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`${tileClass} rounded-sm border border-border bg-secondary cursor-zoom-in shrink-0 hover:border-cyan-400/60 transition-colors`}
        title={caption ? `${caption} — Klick vergrößert` : "Klick vergrößert"}
      />
      {open && (
        <div
          data-testid={`${testId}-lightbox`}
          onClick={(e) => { e.stopPropagation(); setOpen(false); }}
          className="fixed inset-0 z-[120] bg-black/85 flex flex-col items-center justify-center gap-2 cursor-zoom-out p-6"
        >
          <img
            src={src}
            alt={alt}
            className="max-w-[92vw] max-h-[85vh] rounded-sm border border-border"
          />
          {caption && (
            <div className="font-mono text-[11px] text-zinc-300 text-center">
              {caption} · Klick schließt
            </div>
          )}
        </div>
      )}
    </>
  );
}
